import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { shadows, textStyles, colorPalette } from '../../styles/styleGuide';
import { toBreakpoint } from '../../styles/breakpoints';
import BBCode from '../shared/richText/BBCode';
import get from 'lodash.get';
var EditProfileModal = /*#__PURE__*/function (_Component) {
  function EditProfileModal() {
    _classCallCheck(this, EditProfileModal);
    return _callSuper(this, EditProfileModal, arguments);
  }
  _inherits(EditProfileModal, _Component);
  return _createClass(EditProfileModal, [{
    key: "render",
    value: function render() {
      var _this = this;
      var changedFields = [];
      Object.keys(this.props.values).map(function (value) {
        return _this.props.form.filter(function (cat) {
          if (cat.options.find(function (option) {
            return option.name === value;
          }) && value !== 'users') {
            changedFields.push(cat.options.find(function (option) {
              return option.name === value;
            }));
          }
          return changedFields;
        });
      });
      return __jsx(Container, {
        "data-id": "dashboard_EditProfileModal_Container"
      }, __jsx(Title, {
        "data-id": "dashboard_EditProfileModal_Title"
      }, "Gelukt!"), __jsx(Description, {
        "data-id": "dashboard_EditProfileModal_Description"
      }, "Je hebt de volgende profielgegevens aangepast:"), changedFields.map(function (field, index) {
        return __jsx(BBCode, {
          key: index,
          content: {
            content: "[ul][li]".concat(String(get(field, 'label')), "[/ul][/li]")
          },
          "data-id": "dashboard_EditProfileModal_BBCode"
        });
      }));
    }
  }]);
}(Component);
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: #fff;\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", "\n\n  > div {\n    margin-bottom: -12rem;\n  }\n"])), shadows.boxPrimary, toBreakpoint.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), toBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 40rem 30rem 40rem 30rem;\n  "]))));
var Title = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: 10rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var Description = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: 30rem;\n"])), textStyles.subTitle, colorPalette.textGrey);
export default EditProfileModal;